import React from "react";
import renderIcon from "../../../components/renderIcon";

/**
 * État vide standard du thème 2026.
 * Utilisé sur les pages liste (Events, Galeries, Actu, Horaires…) quand
 * aucune donnée n'est disponible.
 *
 * Props :
 *   - icon    : nom d'icône Tabler (ex. "IconCalendarOff", "IconPhotoOff")
 *   - title   : titre éditorial
 *   - subtitle: phrase explicative
 *   - children: contenu optionnel additionnel (bouton CTA…)
 */
const styles = `
.t26-empty {
  text-align: center;
  padding: clamp(60px, 10vw, 100px) 20px;
  color: var(--ink-3);
  display: flex; flex-direction: column; align-items: center;
}
.t26-empty__icon {
  color: color-mix(in oklab, var(--primary) 50%, transparent);
  opacity: .6;
  margin-bottom: 16px;
}
.t26-empty__title {
  font-family: var(--font-display);
  font-size: clamp(22px, 2.6vw, 26px);
  font-weight: 700;
  color: var(--ink);
  margin: 0 0 8px;
  text-wrap: balance;
}
.t26-empty__sub {
  font-size: 15px;
  max-width: 48ch;
  margin: 0 auto;
  line-height: 1.55;
}
.t26-empty__extra { margin-top: 20px; }
`;

export default function EmptyState({ icon = "IconInbox", title, subtitle, children }) {
    return (
        <>
            <style dangerouslySetInnerHTML={{ __html: styles }} />
            <div className="t26-empty">
                <div className="t26-empty__icon">
                    {renderIcon({ name: icon, source: "tabler" }, 72)}
                </div>
                {title && <h2 className="t26-empty__title">{title}</h2>}
                {subtitle && <p className="t26-empty__sub">{subtitle}</p>}
                {children && <div className="t26-empty__extra">{children}</div>}
            </div>
        </>
    );
}
